<div style="padding: 16px;">
    <div nz-row [nzGutter]="[10, 10]">
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" nzXXl="12">
            <div #chartContainer class="app-shadow"></div>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" nzXXl="12">
            <div class="app-shadow">
                <nz-radio-group class="radio-gorup">
                    <label nz-radio nzValue="A">GP</label>
                    <label nz-radio nzValue="B">BL</label>
                    <label nz-radio nzValue="C">ROBI</label>
                    <label nz-radio nzValue="D">BKash</label>
                </nz-radio-group>
                <div class="renew-chart-container" #chartContainerRevenew></div>
            </div>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" nzXXl="12">
            <div #comparismChartContainer class="app-shadow"></div>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" nzXXl="12">
            <div #comparismChartContainerMonthly class="app-shadow"></div>
        </div>
    </div>
</div>
